import { createSlice, createAction } from '@reduxjs/toolkit';
import initialState from '../../../domain/app/ui/loaders';

// ------- SAGA ------ //

function changeStatusError(state, action) {
  const { isError } = action.payload;
  state.errorStatus = isError;
}

const fetchErrorGeneral = createAction('fetchErrorGeneral');


const errorReducer = createSlice({
  name: 'ErrorGeneral',
  initialState,
  reducers: {
    changeStatusError
  },
});

export const errorGeneralActions = {
  ...errorReducer.actions,
  fetchErrorGeneral
};

export default errorReducer.reducer;
